import { render, staticRenderFns } from "./ShowBasicInfo.vue?vue&type=template&id=22227ace"
import script from "./ShowBasicInfo.vue?vue&type=script&lang=js"
export * from "./ShowBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports